/// <reference lib="dom" />
import { useEffect, useRef, useState } from "preact/hooks";

export function useChart<TChart extends { destroy(): void }>(
  create: (container: HTMLDivElement) => TChart,
  deps: readonly unknown[],
): { ref: { current: HTMLDivElement | null }; chart: TChart | null } {
  const ref = useRef<HTMLDivElement>(null);
  const [chart, setChart] = useState<TChart | null>(null);

  useEffect(() => {
    if (!ref.current) return;
    const next = create(ref.current);
    setChart(next);
    return () => next.destroy();
  }, deps);

  return { ref, chart };
}

export function useLatest<T>(value: T): { current: T } {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
